import React, { ReactElement } from 'react';
import { Col, Row, Card, Tooltip, Button, notification } from 'antd';
import styles from './AppCodeCard.module.less';
import { useHover } from '../core/hooks/useHover';
import { CopyOutlined } from '@severalnines/frontend_hub/libs/icons';
import CcxComponentProps from '../core/CcxComponent';
import CcxIconCheckCircle from './ccx/icons/CcxIconCheckCircle';

interface AppCodeCardProps extends CcxComponentProps {
    children?: any;
    className?: string;
    usageExample?: string[];
}

function AppCodeCard({
    children,
    className,
    usageExample,
    testId = 'AppCodeCard',
}: AppCodeCardProps): ReactElement {
    const [hoverRef, isHovered] = useHover<HTMLDivElement>();

    const handleClick = () => {
        copyMessage(usageExample ? usageExample.join('\r\n') : children);
        notification.open({
            message: 'Clipboard Updated',
            description: 'Copied to clipboard.',
            icon: <CcxIconCheckCircle />,
        });
    };

    const copyMessage = (val: string | undefined) => {
        if (!val) {
            return;
        }

        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    };

    return (
        <Card
            className={`${styles.AppCodeCard}`}
            bordered={false}
            data-testid={testId}
        >
            <Row style={{ width: '100%', alignItems: 'center' }}>
                <Col span={23}>
                    <code>{children}</code>
                </Col>
                <Col span={1} className={styles.AppCodeCardCol}>
                    <div ref={hoverRef}>
                        <Tooltip
                            placement="bottom"
                            title={'Click to copy to clipboard.'}
                            {...{
                                onClick: handleClick,
                            }}
                        >
                            <Button
                                type="link"
                                data-testid={`${testId}CopyIcon`}
                                className={styles.AppCodeCardCopyIcon}
                            >
                                {isHovered ? (
                                    <CopyOutlined />
                                ) : (
                                    <CopyOutlined />
                                )}
                            </Button>
                        </Tooltip>
                    </div>
                </Col>
            </Row>
        </Card>
    );
}

export default AppCodeCard;
